import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { moduleName } from './constants'
import { ISignUpState } from './types'

const initialState: ISignUpState = {
  token: '',
  email: ''
}

const slice = createSlice({
  name: moduleName,
  initialState,
  reducers: {
    setSignUpData(state: ISignUpState, action: PayloadAction<ISignUpState>) {
      const { token, email } = action.payload
      state.token = token
      state.email = email
    }
  }
})

export default slice.reducer
export const { setSignUpData } = slice.actions
